import {Item1} from '../../../../../../../_metronic/partials/content/activity/Item1'
import {Item2} from '../../../../../../../_metronic/partials/content/activity/Item2'
import {Item3} from '../../../../../../../_metronic/partials/content/activity/Item3'
import {Item5} from '../../../../../../../_metronic/partials/content/activity/Item5'

export default function History() {
  return (
    <div className='card shadow-none rounded-0'>
      <div className='card-header' id='kt_activities_header'>
        <h3 className='card-title fw-bolder text-dark'>Activity Logs</h3>
      </div>
      <div className='card-body position-relative' id='kt_activities_body'>
        <div
          id='kt_activities_scroll'
          className='position-relative scroll-y me-n5 pe-5'
          data-kt-scroll='true'
          data-kt-scroll-height='auto'
          data-kt-scroll-wrappers='#kt_activities_body'
          data-kt-scroll-dependencies='#kt_activities_header, #kt_activities_footer'
          data-kt-scroll-offset='5px'
        >
          <div className='timeline'>
            <Item1 />
            <Item2 />
            <Item3 />
            <Item5 />
          </div>
        </div>
      </div>
    </div>
  )
}
